"use client";

import { useGetCartQuery } from "@/api/AppApi/services/cart";
import { useGetCompanyQuery } from "@/api/AppApi/services/company";
import useIsClient from "@/hooks/useIsClient";
import useSellingMode from "@/hooks/useSellingMode";

const SvgCartLayout: React.FC<{ inHeader?: boolean }> = ({ inHeader }) => {
  const client = useIsClient();
  const getCompany = useGetCompanyQuery();
  const { enableSells } = useSellingMode();
  const getCart = useGetCartQuery();
  const { show_cart } = getCompany?.data?.result?.theme?.settings ?? {};
  const mobile_match_desktop_design =
    getCompany?.data?.result?.theme.colors.mobile_match_desktop_design;
  const cartItemsLen = getCart?.data?.result?.items.length ?? 0;
  const disabled = !show_cart && !enableSells;
  const fill = inHeader
    ? mobile_match_desktop_design
      ? "fill-headerIconsColor"
      : "fill-dark"
    : "fill-dark";
  if (!client) return;
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.45812 2.5C1.3753 2.49883 1.29307 2.51413 1.21622 2.54501C1.13936 2.5759 1.06941 2.62175 1.01043 2.6799C0.95145 2.73805 0.904615 2.80735 0.872648 2.88376C0.840681 2.96017 0.824219 3.04217 0.824219 3.125C0.824219 3.20783 0.840681 3.28983 0.872648 3.36624C0.904615 3.44265 0.95145 3.51195 1.01043 3.5701C1.06941 3.62825 1.13936 3.6741 1.21622 3.70499C1.29307 3.73587 1.3753 3.75117 1.45812 3.75H2.6064C2.9097 3.75 3.16253 3.95955 3.22 4.25781L3.34451 4.90886L4.6881 11.9653C4.93107 13.2385 6.05276 14.1667 7.34923 14.1667H15.1503C16.4468 14.1667 17.569 13.2388 17.8115 11.9653L19.1551 4.90886C19.1723 4.81851 19.1694 4.72547 19.1465 4.63638C19.1237 4.54729 19.0814 4.46434 19.0228 4.39345C18.9642 4.32256 18.8907 4.26548 18.8075 4.22628C18.7243 4.18708 18.6334 4.16672 18.5415 4.16667H4.47488L4.44803 4.02425C4.28006 3.14397 3.50269 2.5 2.6064 2.5H1.45812ZM4.71333 5.41667H17.7862L16.5834 11.7318C16.4518 12.4233 15.8547 12.9167 15.1503 12.9167H7.34923C6.64512 12.9167 6.04845 12.4233 5.91613 11.7318V11.731L4.71333 5.41667ZM8.33312 15C8.0016 15 7.68366 15.1317 7.44924 15.3661C7.21482 15.6005 7.08312 15.9185 7.08312 16.25C7.08312 16.5815 7.21482 16.8995 7.44924 17.1339C7.68366 17.3683 8.0016 17.5 8.33312 17.5C8.66464 17.5 8.98258 17.3683 9.217 17.1339C9.45142 16.8995 9.58312 16.5815 9.58312 16.25C9.58312 15.9185 9.45142 15.6005 9.217 15.3661C8.98258 15.1317 8.66464 15 8.33312 15ZM14.1665 15C13.8349 15 13.517 15.1317 13.2826 15.3661C13.0481 15.6005 12.9165 15.9185 12.9165 16.25C12.9165 16.5815 13.0481 16.8995 13.2826 17.1339C13.517 17.3683 13.8349 17.5 14.1665 17.5C14.498 17.5 14.8159 17.3683 15.0503 17.1339C15.2848 16.8995 15.4165 16.5815 15.4165 16.25C15.4165 15.9185 15.2848 15.6005 15.0503 15.3661C14.8159 15.1317 14.498 15 14.1665 15Z"
        className={fill}
      />
      {!disabled && cartItemsLen > 0 && (
        <>
          <circle cx="15" cy="15" r="6" fill={"red"} />
          <text
            fill={"white"}
            fontSize={7}
            x="15"
            y="15"
            textAnchor="middle"
            alignmentBaseline="middle"
          >
            {cartItemsLen}
          </text>
        </>
      )}
    </svg>
  );
};

export default SvgCartLayout;
